import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/purchaseGift',
  component: LAYOUT,
  name: 'PurchaseGift',
  redirect: '/purchaseGift/index',
  meta: {
    title: '推荐送好礼',
  },
  children: [
    {
      path: 'index',
      name: 'purchaseGiftIndex',
      meta: {
        title: '推荐赢好礼',
      },

      component: () => import('@/views/purchaseGift/index'),
    },
    {
      path: 'myScore',
      name: 'purchaseGiftMyScore',
      meta: {
        title: '我的战绩',
      },
      component: () => import('@/views/purchaseGift/myScore'),
    },
    {
      path: 'commitPlayers',
      name: 'purchaseGiftCommitPlayers',
      meta: {
        title: '提交资料',
      },
      component: () => import('@/views/purchaseGift/commitPlayers'),
    },
    {
      path: 'joinRecord',
      name: 'purchaseGiftJoinRecord',
      meta: {
        title: '参与记录',
      },
      component: () => import('@/views/purchaseGift/joinRecord'),
    },
    {
      path: 'joinDetail',
      name: 'purchaseGiftJoinDetail',
      meta: {
        title: '参与详情',
      },
      component: () => import('@/views/purchaseGift/joinDetail'),
    },
    {
      path: 'activeDetail',
      name: 'purchaseGiftActiveDetail',
      meta: {
        title: '活动详情',
      },
      component: () => import('@/views/purchaseGift/activeDetail'),
    },
    {
      path: 'shareBanner',
      name: 'purchaseGiftShareBanner',
      meta: {
        title: '分享海报',
      },
      component: () => import('@/views/purchaseGift/shareBanner'),
    },
    {
      path: 'myJoin',
      name: 'purchaseGiftMyJoin',
      meta: {
        title: '推荐赢好礼',
      },
      component: () => import('@/views/purchaseGift/myJoin'),
    },
    {
      path: 'shareActive',
      name: 'purchaseGiftShareActive',
      meta: {
        title: '分享活动',
      },
      component: () => import('@/views/purchaseGift/shareActive'),
    },
  ],
};
